import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

export const styles = makeStyles(theme => ({
  innerContainer: {
    paddingLeft: '2.34vw',
    paddingBottom: '4.25vh',
  },
  innerTitle: {
    backgroundColor: 'white',
    width: '100%',
    fontSize: vh(3.125),
    fontWeight: 500,
    padding: '1.95vh 1.83vw',
    height: '7.29vh',
  },
  dialogTitleText: {
    fontSize: vh(2.604),
    fontWeight: 500,
    letterSpacing: '0.02vw',
    color: themeColor.defaultTextColor,
  },
  instructionTitle: {
    marginTop: '2vh',
    fontSize: vh(2.604),
    opacity: '0.87',
    letterSpacing: '0.046vw',
  },
  instructionMessage: {
    marginTop: '2vh',
    fontSize: vh(2.604),
    opacity: '0.6',
    fontWeight: 500,
    letterSpacing: '0.017vw',
  },
  bottom: {
    alignSelf: 'flex-end',
  },
  icon: {
    display: 'inline-block',
    height: '2.8vh',
    width: '2.3vw',
    color: themeColor.alert,
  },
  errorMessage: {
    fontSize: vh(2.35),
    color: theme.palette.info.dark,
    marginLeft: '0.6vw',
    fontWeight: 500,
  },
  cancelLabel: {
    fontSize: vh(2.08),
    letterSpacing: '0.092vw',
    color: themeColor.defaultTextColor,
  },
  errorContainer: {
    flexWrap: 'nowrap',
    marginTop: '1.95vh',
  },
}));
